import type {
  AnchorHTMLAttributes,
  ReactNode,
} from "react";

type MarketingButtonVariant =
  | "primary"
  | "secondary"
  | "ghost";

interface MarketingButtonProps
  extends AnchorHTMLAttributes<HTMLAnchorElement> {
  children: ReactNode;
  variant?: MarketingButtonVariant;
}

const variants: Record<
  MarketingButtonVariant,
  string
> = {
  primary:
    "bg-indigo-500 text-white shadow-lg shadow-indigo-500/20 hover:bg-indigo-400",
  secondary:
    "border border-white/15 bg-white/5 text-white hover:border-white/25 hover:bg-white/10",
  ghost:
    "text-slate-300 hover:bg-white/5 hover:text-white",
};

export function MarketingButton({
  children,
  variant = "primary",
  className = "",
  ...props
}: MarketingButtonProps) {
  return (
    <a
      className={[
        "inline-flex items-center justify-center rounded-xl",
        "px-5 py-3 text-sm font-semibold",
        "transition duration-200",
        "focus:outline-none focus:ring-2",
        "focus:ring-indigo-400 focus:ring-offset-2",
        "focus:ring-offset-slate-950",
        variants[variant],
        className,
      ].join(" ")}
      {...props}
    >
      {children}
    </a>
  );
}
